<footer class="footer-placeholder" [attr.lang]="currentLanguage.code">
  <div class="footer-placeholder__grid">
    <section>
      <h2>{{ getTranslation('contactus') }}</h2>
      <address>
        <span>{{ siteConfig.address(currentLanguage.code) }}</span>
        <a
          [href]="'tel:' + siteConfig.phoneNumber()"
          [attr.aria-label]="siteConfig.socialAriaLabel('phone', currentLanguage.code)"
        >{{ siteConfig.phoneDisplay() }}</a>
        <a
          [href]="'mailto:' + siteConfig.emailAddress()"
          [attr.aria-label]="siteConfig.socialAriaLabel('email', currentLanguage.code)"
        >{{ siteConfig.emailAddress() }}</a>
      </address>
      <p class="footer-placeholder__inline-links">
        <a [href]="siteConfig.socialUrl('whatsapp', currentLanguage.code)" target="_blank" rel="noopener">WhatsApp</a>
        <a [href]="siteConfig.socialUrl('telegram', currentLanguage.code)" target="_blank" rel="noopener">Telegram</a>
      </p>
    </section>

    <nav [attr.aria-label]="getTranslation('quicklinks')">
      <h2>{{ getTranslation('quicklinks') }}</h2>
      <ul>
        <li><a [href]="homePath()">{{ getTranslation('home') }}</a></li>
        <li><a [href]="menuPath('aboutUs')">{{ getTranslation('aboutus') }}</a></li>
        <li><a [href]="menuPath('services')">{{ getTranslation('ourservices') }}</a></li>
        <li><a [href]="menuPath('gallery')">{{ getTranslation('gallery') }}</a></li>
        <li><a [href]="menuPath('faq')">{{ getTranslation('faq') }}</a></li>
        <li><a [href]="menuPath('paymentOptions')">{{ getTranslation('paymentOptions') }}</a></li>
        <li><a [href]="menuPath('airportTransferPrices')">{{ navbarMenu.airportTransferPrices.name[currentLanguage.code] }}</a></li>
        <li><a [href]="quoteHubPath()">{{ navbarMenu.quoteRoutes.name[currentLanguage.code] }}</a></li>
        <li><a [href]="menuPath('contactUs')">{{ getTranslation('contact') }}</a></li>
        <li><a [href]="menuPath('blogs')">{{ getTranslation('blog') }}</a></li>
      </ul>
    </nav>

    <nav [attr.aria-label]="getTranslation('allLanguages')">
      <h2>{{ getTranslation('allLanguages') }}</h2>
      <ul>
        <li (click)="onLanguageSelect('en')"><a [href]="homePath('en')">English</a></li>
        <li (click)="onLanguageSelect('de')"><a [href]="homePath('de')">Deutsch</a></li>
        <li (click)="onLanguageSelect('ru')"><a [href]="homePath('ru')">Русский</a></li>
        <li (click)="onLanguageSelect('tr')"><a [href]="homePath('tr')">Türkçe</a></li>
      </ul>
    </nav>
  </div>

  <section class="footer-placeholder__seo" *ngIf="hasFooterSeoLinks">
    <div *ngIf="airportSeoLinks.length > 0">
      <h2>{{ getTranslation('pricesByAirport') }}</h2>
      <ul>
        <li *ngFor="let link of airportSeoLinks; trackBy: trackSeoLink">
          <a [href]="link.path">{{ link.label }}</a>
        </li>
      </ul>
    </div>
    <div *ngIf="destinationSeoLinks.length > 0">
      <h2>{{ getTranslation('popularDestinations') }}</h2>
      <ul>
        <li *ngFor="let link of destinationSeoLinks; trackBy: trackSeoLink">
          <a [href]="link.path">{{ link.label }}</a>
        </li>
      </ul>
    </div>
  </section>

  <p class="footer-placeholder__bottom">
    &copy; 2025 Airport Transfer Hub {{ getTranslation('allRightsReserved') }}
    <a [href]="menuPath('privacyPolicy')">{{ navbarMenu.privacyPolicy.name[currentLanguage.code] }}</a>
    <a [href]="menuPath('termsOfService')">{{ navbarMenu.termsOfService.name[currentLanguage.code] }}</a>
  </p>
</footer>
